import { useAtomValue } from 'jotai';
import { useMutation } from 'react-query';

import { Customer, customerAtom } from 'atons/Customer/atoms';
import { deleteCustomFieldGroup } from 'services/groupsApis';
import { useToast } from 'customHooks/useToast';

import { queryClient } from 'react-query/queryClient';
import { queryKeys } from 'react-query/constants';
import { ReactQueryHookOption } from 'react-query/types';
import { useSetErrorMessage } from 'customHooks/useSetErrorMessage';

const useDeleteCustomFieldGroup = (options?: ReactQueryHookOption<void>) => {
    const customer = useAtomValue(customerAtom);
    const onError = useSetErrorMessage();

    const toast = useToast();

    return useMutation((payload: number[]) => deleteCustomFieldGroup(payload, customer as Customer), {
        onSuccess: data => {
            queryClient.invalidateQueries([queryKeys.customFieldGroups]);
            toast.success('Deleted Successfully!');
            if (options?.onSuccess) options.onSuccess(data);
        },
        onError: error => {
            onError(error);
            if (options?.onError) options.onError(error);
        },
    });
};

export default useDeleteCustomFieldGroup;
